<template>
  <div class="homePage">
    <!-- PC端布局 -->
    <div class="pc-layout">
      <div class="detail-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <span class="breadcrumb-item" @click="goToHome">{{ $t("common.latestNews.home") }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-item clickable" @click="goToAllNews">{{ $t("common.latestNews.allAnnouncements") }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-item current">{{ options.title || $t("common.latestNews.announcementDetail") }}</span>
        </div>

        <!-- 公告内容 -->
        <div class="news-content">
          <h2 class="news-title">{{ options.title }}</h2>
          <div class="news-meta">
            <span class="publish-time">{{ $t("common.latestNews.publishTimeLabel") }}{{ options.dateline | dateFormat }}</span>
          </div>
          <div class="news-body" v-html="options.content"></div>
        </div>

        <!-- 返回按钮 -->
        <div class="back-section">
          <button class="back-btn" @click="goToAllNews">{{ $t("common.latestNews.backToAllAnnouncements") }}</button>
        </div>
      </div>
    </div>

    <!-- 移动端布局 -->
    <div class="mobile-layout">
      <!-- 顶部导航栏 -->
      <div class="mobile-header">
        <span class="back-btn" @click="goToAllNews">{{ $t("common.latestNews.backToAnnouncements") }}</span>
        <h3>{{ $t("common.latestNews.announcementDetail") }}</h3>
      </div>

      <!-- 公告标题 -->
      <div class="mobile-title-section">
        <h2 class="mobile-title">{{ options.title }}</h2>
        <div class="mobile-meta">
          <span class="publish-time">{{ options.dateline | dateFormat }}</span>
        </div>
      </div>

      <!-- 公告内容 -->
      <div class="mobile-content">
        <div class="mobile-body" v-html="options.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsItem } from "@/api/user";

export default {
  filters: {
    dateFormat(data) {
      if (!data) return '-';
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
  },
  data() {
    return {
      options: {}
    };
  },
  components: {},
  methods: {
    goToHome() {
      this.$router.push("/");
    },
    goToAllNews() {
      this.$router.push("/module/allNews");
    },
  },
  created() {
  
  },
  mounted() {
    if(this.$route.query.id){
        getNewsItem({id:this.$route.query.id}).then(res=>{
            if(res.code===200){
                this.options=res.data
            }
        })
    }
  },
};
</script>

<style lang="scss" scoped>
.homePage {
  min-height: calc(100vh - 60px);
  background-color: #f5f7fa;
}

// ==================== PC端样式 ====================
.pc-layout {
  padding: 20px 140px;
  min-height: calc(100vh - 80px);
}

.detail-container {
  max-width: 1200px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

// 面包屑导航
.breadcrumb {
  padding: 15px 0;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 30px;
  font-size: 14px;

  .breadcrumb-item {
    color: #666;

    &.clickable {
      cursor: pointer;
      text-decoration: underline;

      &:hover {
        color: #409eff;
      }
    }

    &.current {
      color: #409eff;
      font-weight: 500;
    }
  }

  .breadcrumb-separator {
    margin: 0 8px;
    color: #999;
  }
}

// 公告内容
.news-content {
  .news-title {
    font-size: 28px;
    color: #333;
    margin: 0 0 15px 0;
    font-weight: 600;
    line-height: 1.4;
  }

  .news-meta {
    margin-bottom: 25px;
    padding-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;

    .publish-time {
      font-size: 14px;
      color: #999;
    }
  }

  .news-body {
    font-size: 16px;
    color: #666;
    line-height: 1.8;

    ::v-deep {
      p {
        margin: 15px 0;
      }

      img {
        max-width: 100%;
        height: auto;
        border-radius: 4px;
        margin: 15px 0;
      }

      a {
        color: #409eff;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }

      h1, h2, h3, h4, h5, h6 {
        margin: 20px 0 10px 0;
        color: #333;
        font-weight: 600;
      }

      ul, ol {
        padding-left: 25px;
        margin: 15px 0;
      }

      li {
        margin: 8px 0;
      }

      blockquote {
        padding: 10px 15px;
        margin: 15px 0;
        background: #f5f7fa;
        border-left: 4px solid #409eff;
        color: #666;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        margin: 15px 0;

        th, td {
          padding: 10px;
          border: 1px solid #e8e8e8;
          text-align: left;
        }

        th {
          background: #fafbfc;
          font-weight: 600;
        }
      }
    }
  }
}

// 返回按钮
.back-section {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #e8e8e8;

  .back-btn {
    padding: 10px 20px;
    background: #ffffff;
    border: 1px solid #409eff;
    color: #409eff;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: #409eff;
      color: #ffffff;
    }
  }
}

// ==================== 移动端样式 ====================
.mobile-layout {
  display: none;
  min-height: calc(100vh - 50px);
  background-color: #f5f7fa;
}

// 移动端顶部导航
.mobile-header {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #ffffff;
  border-bottom: 1px solid #e8e8e8;
  position: sticky;
  top: 0;
  z-index: 10;

  .back-btn {
    font-size: 14px;
    color: #409eff;
    cursor: pointer;
    margin-right: 15px;
    
    &:active {
      opacity: 0.7;
    }
  }

  h3 {
    margin: 0;
    font-size: 16px;
    color: #333;
    font-weight: 600;
  }
}

// 移动端标题区域
.mobile-title-section {
  background: #ffffff;
  padding: 20px 15px;
  border-bottom: 1px solid #f0f0f0;

  .mobile-title {
    margin: 0 0 10px 0;
    font-size: 20px;
    color: #333;
    font-weight: 600;
    line-height: 1.5;
  }

  .mobile-meta {
    .publish-time {
      font-size: 13px;
      color: #999;
    }
  }
}

// 移动端内容区域
.mobile-content {
  background: #ffffff;
  padding: 20px 15px;
  min-height: calc(100vh - 200px);

  .mobile-body {
    font-size: 15px;
    color: #666;
    line-height: 1.8;

    ::v-deep {
      p {
        margin: 12px 0;
      }

      img {
        max-width: 100%;
        height: auto;
        border-radius: 4px;
        margin: 12px 0;
      }

      a {
        color: #409eff;
        text-decoration: none;

        &:active {
          opacity: 0.7;
        }
      }

      h1, h2, h3, h4, h5, h6 {
        margin: 18px 0 8px 0;
        color: #333;
        font-weight: 600;
      }

      ul, ol {
        padding-left: 20px;
        margin: 12px 0;
      }

      li {
        margin: 6px 0;
      }

      blockquote {
        padding: 10px 12px;
        margin: 12px 0;
        background: #f5f7fa;
        border-left: 3px solid #409eff;
        color: #666;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        margin: 12px 0;
        font-size: 14px;

        th, td {
          padding: 8px;
          border: 1px solid #e8e8e8;
          text-align: left;
        }

        th {
          background: #fafbfc;
          font-weight: 600;
        }
      }
    }
  }
}

// ==================== 响应式媒体查询 ====================

// 平板端
@media screen and (max-width: 1024px) {
  .pc-layout {
    padding: 20px 60px;
  }
}

// 移动端 - 隐藏PC布局，显示移动布局
@media screen and (max-width: 768px) {
  .pc-layout {
    display: none;
  }

  .mobile-layout {
    display: block;
  }

  .homePage {
    min-height: calc(100vh - 50px);
  }
}
</style>
